import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { SyndicateSummaryComponent } from "../syndicate-summary/syndicate-summary.component";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { ExpandableComponent } from "../expandable/expandable.component";
import { NgClass } from "@angular/common";
@Component({
    selector: "app-setup-complete",
    templateUrl: "./setup-complete.component.html",
    styleUrls: ["./setup-complete.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        RouterLink,
        ExpandableComponent,
        NgClass,
        TranslatePipe,
    ],
})
export class SetupCompleteComponent implements OnInit {
  cardExpanded = true;
  calculatedTopMargin = 0;
  mockResponse = [
    {
      name: "Euromillions",
      day: "Tuesday",
      count: 1,
    },
    {
      name: "Megamillions",
      day: "Friday",
      count: 2,
    },
    {
      name: "Megamillions",
      day: "Wednesday",
      count: 2,
    },
  ];

  constructor(
    private router: Router,
    private bottomSheet: MatBottomSheet,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  calculateItemHeight(sourceArray: any) {
    /* Height measure in vh */
    const defaultHeight = 9.85;
    this.calculatedTopMargin = sourceArray?.length * defaultHeight;
    return sourceArray?.length * defaultHeight;
  }

  calculatedMargin(sourceArray: any) {
    /* Style calculation */
    var style = {
      height: "10vh",
    };
    if (this.cardExpanded) {
      style.height = "0";
    } else {
      style.height = String(this.calculateItemHeight(sourceArray)) + "vh";
    }
    return style;
  }

  showSyndicateSummary() {
    this.bottomSheet.open(SyndicateSummaryComponent, {
      panelClass: "syndicate-summary-dialog",
    });
  }
}
